import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LegalPage.css';
import './FaqPage.css';

const FAQS = [
  {
    category: '🚀 Γενικά',
    items: [
      {
        q: 'Τι είναι το SalonBook;',
        a: 'Το SalonBook είναι μια επαγγελματική πλατφόρμα διαχείρισης κρατήσεων για κομμωτήρια και χώρους ομορφιάς. Σας επιτρέπει να διαχειρίζεστε ραντεβού, πελάτες, υπαλλήλους και υπηρεσίες από ένα κεντρικό σημείο.'
      },
      {
        q: 'Χρειάζομαι τεχνικές γνώσεις για να το χρησιμοποιήσω;',
        a: 'Όχι! Το SalonBook σχεδιάστηκε για να είναι απλό και εύχρηστο. Αν ξέρετε να χρησιμοποιείτε smartphone, μπορείτε να χρησιμοποιήσετε το SalonBook.'
      },
      {
        q: 'Λειτουργεί σε κινητό τηλέφωνο;',
        a: 'Ναι! Το SalonBook είναι πλήρως responsive και λειτουργεί σε όλες τις συσκευές — desktop, tablet και smartphone.'
      },
      {
        q: 'Πόσο κοστίζει;',
        a: 'Προσφέρουμε διάφορα πλάνα ανάλογα με τις ανάγκες σας. Επισκεφτείτε τη σελίδα Τιμολόγησης για λεπτομέρειες. Υπάρχει και δωρεάν δοκιμαστική περίοδος 14 ημερών χωρίς πιστωτική κάρτα.'
      },
    ]
  },
  {
    category: '📅 Κρατήσεις',
    items: [
      {
        q: 'Πώς προσθέτω μια νέα κράτηση;',
        a: 'Πατήστε το κουμπί "+ Κράτηση" στο ημερολόγιο ή κλικάρετε σε οποιαδήποτε ώρα στο πλέγμα. Συμπληρώστε το όνομα πελάτη, υπηρεσία και ώρα και αποθηκεύστε.'
      },
      {
        q: 'Μπορώ να αλλάξω ώρα μιας κράτησης;',
        a: 'Ναι! Κλικάρετε στην κράτηση στο ημερολόγιο, επιλέξτε "Επεξεργασία" και αλλάξτε την ώρα ή ημερομηνία.'
      },
      {
        q: 'Πώς λειτουργεί ο έλεγχος διαθεσιμότητας;',
        a: 'Το σύστημα ελέγχει αυτόματα αν υπάρχει σύγκρουση με άλλη κράτηση και σας προτείνει εναλλακτικές ώρες αν η επιλεγμένη δεν είναι διαθέσιμη.'
      },
      {
        q: 'Μπορώ να προσθέσω έκπτωση σε μια κράτηση;',
        a: 'Ναι! Κατά τη δημιουργία ή επεξεργασία κράτησης, υπάρχει πεδίο "Τιμή / Έκπτωση" όπου μπορείτε να βάλετε διαφορετική τιμή από την κανονική τιμή της υπηρεσίας.'
      },
      {
        q: 'Τι είναι το φιλοδώρημα (tip);',
        a: 'Μπορείτε να καταγράψετε το φιλοδώρημα που έδωσε ο πελάτης. Εμφανίζεται στα στατιστικά και στην κάρτα κράτησης.'
      },
    ]
  },
  {
    category: '👥 Πελάτες & Υπάλληλοι',
    items: [
      {
        q: 'Πώς προσθέτω νέο πελάτη;',
        a: 'Ο πελάτης προστίθεται αυτόματα όταν κάνετε την πρώτη του κράτηση. Μπορείτε επίσης να πάτε στη σελίδα "Πελάτες" και να πατήσετε "+ Νέος πελάτης".'
      },
      {
        q: 'Πώς προσθέτω υπάλληλο;',
        a: 'Πηγαίνετε στη σελίδα "Χρήστες" (μόνο admin) και πατήστε "+ Νέος χρήστης". Συμπληρώστε email, κωδικό και επιλέξτε τα δικαιώματα που θέλετε να έχει.'
      },
      {
        q: 'Τι δικαιώματα μπορώ να δώσω σε υπάλληλο;',
        a: 'Υπάρχουν 3 επίπεδα: Βασικός (μόνο ημερολόγιο), Κρατήσεων (ημερολόγιο + κρατήσεις), Πελατών (ημερολόγιο + κρατήσεις + πελάτες). Ο admin βλέπει τα πάντα.'
      },
      {
        q: 'Μπορώ να απενεργοποιήσω έναν υπάλληλο;',
        a: 'Ναι! Στη σελίδα "Χρήστες" μπορείτε να απενεργοποιήσετε προσωρινά ή να διαγράψετε οποιοδήποτε υπάλληλο.'
      },
    ]
  },
  {
    category: '📊 Στατιστικά',
    items: [
      {
        q: 'Τι στατιστικά μπορώ να δω;',
        a: 'Μπορείτε να δείτε: κρατήσεις ανά ημέρα, έσοδα, ανά υπηρεσία, ανά υπάλληλο, ανά ώρα, ανά ημέρα εβδομάδας, φιλοδωρήματα και ποσοστό ακύρωσης.'
      },
      {
        q: 'Πώς υπολογίζονται τα έσοδα;',
        a: 'Τα έσοδα υπολογίζονται βάσει της τιμής κάθε κράτησης (ή έκπτωσης αν υπάρχει) συν τυχόν φιλοδώρημα. Ακυρωμένες κρατήσεις δεν συμπεριλαμβάνονται.'
      },
    ]
  },
  {
    category: '⚙️ Τεχνικά',
    items: [
      {
        q: 'Τα δεδομένα μου είναι ασφαλή;',
        a: 'Απολύτως. Χρησιμοποιούμε κρυπτογράφηση SSL/TLS, έλεγχο πρόσβασης βάσει ρόλων και τακτικά αντίγραφα ασφαλείας. Συμμορφωνόμαστε πλήρως με τον GDPR.'
      },
      {
        q: 'Μπορώ να εξάγω τα δεδομένα μου;',
        a: 'Ναι, μπορείτε να εξάγετε τα δεδομένα σας οποτεδήποτε. Επικοινωνήστε μαζί μας στο support@salonbook.gr.'
      },
      {
        q: 'Τι γίνεται αν χαλάσει το internet;',
        a: 'Το SalonBook απαιτεί σύνδεση internet. Συνιστούμε να έχετε εναλλακτική σύνδεση (mobile data) ως backup.'
      },
    ]
  },
];

export default function FaqPage() {
  const navigate = useNavigate();
  const [open, setOpen] = useState({});

  const toggle = (ci, qi) => {
    const key = `${ci}-${qi}`;
    setOpen(prev => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div className="legal-root">
      <header className="legal-header">
        <button className="legal-back" onClick={() => navigate('/')}>← Επιστροφή</button>
        <div className="legal-logo">✂ SalonBook</div>
      </header>

      <div className="legal-content">
        <div className="legal-hero">
          <div className="legal-badge">Υποστήριξη</div>
          <h1>Συχνές Ερωτήσεις</h1>
          <p>Βρείτε απαντήσεις στις πιο συχνές ερωτήσεις για το SalonBook</p>
        </div>

        <div className="faq-body">
          {FAQS.map((cat, ci) => (
            <div key={ci} className="faq-category">
              <h2 className="faq-cat-title">{cat.category}</h2>
              <div className="faq-list">
                {cat.items.map((item, qi) => {
                  const key = `${ci}-${qi}`;
                  const isOpen = !!open[key];
                  return (
                    <div key={qi} className={'faq-item' + (isOpen ? ' faq-open' : '')}
                      onClick={() => toggle(ci, qi)}>
                      <div className="faq-q">
                        <span>{item.q}</span>
                        <span className="faq-icon">{isOpen ? '−' : '+'}</span>
                      </div>
                      {isOpen && <div className="faq-a">{item.a}</div>}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}

          <div className="faq-contact">
            <h3>Δεν βρήκατε την απάντησή σας;</h3>
            <p>Επικοινωνήστε μαζί μας και θα σας βοηθήσουμε άμεσα.</p>
            <a href="mailto:support@salonbook.gr" className="faq-contact-btn">
              📧 support@salonbook.gr
            </a>
          </div>
        </div>
      </div>

      <footer className="legal-footer">
        <span>© {new Date().getFullYear()} SalonBook. Όλα τα δικαιώματα διατηρούνται.</span>
        <div className="legal-footer-links">
          <a href="/privacy">Πολιτική Απορρήτου</a>
          <a href="/terms">Όροι Χρήσης</a>
          <a href="/gdpr">GDPR</a>
        </div>
      </footer>
    </div>
  );
}